import { defaultErrorMessage } from '../constants/messages';
import { EnumsDtoOutErrorTypesEnum } from '../generated';

export const getApiErrorMessage = (e: any): string => {
  console.error('Api error:', e.response?.data || e.response || e);

  switch(e.response?.data?.errorType) {
    case EnumsDtoOutErrorTypesEnum.InvalidOtp: return 'Byl zadán nesprávný ověřovací kód.';
    case EnumsDtoOutErrorTypesEnum.PhoneNumberParse:
      return 'Telefonní číslo je v nesprávném formátu.';
    case EnumsDtoOutErrorTypesEnum.MaxUploadSizeExceeded:
      return 'Soubor je příliš velký. Prosím, nahrajte soubor o maximální velikosti 16MB.';
    case EnumsDtoOutErrorTypesEnum.CouldNotDeliverOtp:
      return 'Vyskytl se problém se zasláním ověřovacího kódu. Zkuste to prosím později.';
    case EnumsDtoOutErrorTypesEnum.InvalidData:
      return 'Zadané údaje nejsou validní. Zkontrolujte je prosím.';
    case EnumsDtoOutErrorTypesEnum.PatientNotFoundInIkem:
      return 'Pro zadané údaje nebyl nalezen žádný pacient.';
    case EnumsDtoOutErrorTypesEnum.CaptchaVerificationFailed:
      return 'Vyskytl se problém s verifikací pomocí Captcha.';
    default:
      console.warn('Unknown error occurred, returning default error message.');
      return defaultErrorMessage;
  }
};
